import { DISABLE_PAYMENTS } from "~/helpers/plans";
import { paths } from "~/router/paths";

export const redirectRoutes = [
  {
    path: paths.settings.index,
    to: DISABLE_PAYMENTS ? paths.settings.account : paths.settings.plans,
  },
  /** Legacy Product Database URL → Product Library */
  {
    path: "/product-database",
    to: paths.app.productLibrary,
  },
  /** Legacy Store Library (Top Stores) URLs */
  {
    path: "/sales-tracker/top-stores",
    to: paths.app.storeLibrary,
  },
  /** My trackings index → default Stores tab */
  {
    path: paths.app.myTrackings,
    to: paths.app.myTrackingStores,
  },
];
